module.exports = __webpack_public_path__ + "media/images/creative-commons-d9e8d53c573ae0931c1cb6da4832cedd.png";